import { render, staticRenderFns } from "./SalesStatisticDialog.vue?vue&type=template&id=bb99aca8&"
import script from "./SalesStatisticDialog.vue?vue&type=script&lang=js&"
export * from "./SalesStatisticDialog.vue?vue&type=script&lang=js&"
import style0 from "./SalesStatisticDialog.vue?vue&type=style&index=0&id=bb99aca8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports